class FabricShowcase {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.swiper = null;
    this.contentElement = container.querySelector('.fabric-showcase__content-inner');
    this.titleElement = container.querySelector('.fabric-showcase__title');
    this.descriptionElement = container.querySelector('.fabric-showcase__description');
    this.overlayElement = container.querySelector('.fabric-showcase__overlay');
    
    this.init();
  }
  
  init() {
    this.initSwiper();
    this.updateContent(0); // Initialize with first slide
    this.applySettings();
  }
  
  initSwiper() {
    const swiperContainer = this.container.querySelector('.fabric-showcase__swiper');
    
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
     loop: true, // Enable looping
      autoplay: {
        delay: 5000, // 5 seconds
        disableOnInteraction: false, // Keeps autoplay running even after user interaction
      },
      navigation: {
        nextEl: this.container.querySelector('.fabric-showcase__nav-next'),
        prevEl: this.container.querySelector('.fabric-showcase__nav-prev'),
      },
      pagination: {
        el: this.container.querySelector('.fabric-showcase__pagination'),
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      
    });
  }
  
  updateContent(slideIndex) {
    const slides = this.container.querySelectorAll('.swiper-slide');
    
    if (slides[slideIndex]) {
      const slide = slides[slideIndex];
      const fabricImage = slide.dataset.fabricImage;
      const fabricTitle = slide.dataset.fabricTitle;
      const fabricDescription = slide.dataset.fabricDescription;
      
      // Update background image
      if (fabricImage && fabricImage !== 'null') {
        // this.contentElement.style.backgroundImage = `url(${fabricImage})`;
      } else {
        this.contentElement.style.backgroundImage = 'none';
        this.contentElement.style.backgroundColor = '#f5f5f5';
      }
      
      // Update title
      if (this.titleElement) {
        this.titleElement.textContent = fabricTitle || 'Fabric Title';
      }
      
      // Update description
      if (this.descriptionElement) {
        this.descriptionElement.innerHTML = fabricDescription || '<p>Fabric description goes here.</p>';
      }
    }
  }
  
  applySettings() {
    const section = document.querySelector(`[data-section-id="${this.sectionId}"]`);
    if (!section) return;
    
    // Apply overlay opacity
    const overlayOpacity = section.dataset.overlayOpacity || 40;
    if (this.overlayElement) {
      this.overlayElement.style.background = `rgba(0, 0, 0, ${overlayOpacity / 100})`;
    }
    
    // Apply text alignment
    const textAlignment = section.dataset.textAlign || 'left';
    section.setAttribute('data-text-align', textAlignment);
  }
  
  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Initialize all fabric showcase sections
document.addEventListener('DOMContentLoaded', function() {
  const fabricShowcases = document.querySelectorAll('.fabric-showcase');
  const instances = [];
  
  fabricShowcases.forEach(container => {
    instances.push(new FabricShowcase(container));
  });
  
  // Handle Shopify theme editor events
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const container = event.target.querySelector('.fabric-showcase');
      if (container) {
        new FabricShowcase(container);
      }
    });
    
    document.addEventListener('shopify:section:unload', function(event) {
      const container = event.target.querySelector('.fabric-showcase');
      if (container && container.fabricShowcaseInstance) {
        container.fabricShowcaseInstance.destroy();
      }
    });
    
    document.addEventListener('shopify:section:select', function(event) {
      const container = event.target.querySelector('.fabric-showcase');
      if (container && container.fabricShowcaseInstance) {
        container.fabricShowcaseInstance.applySettings();
      }
    });
  }
});

// Export for potential external use
window.FabricShowcase = FabricShowcase;